export const findStartRoute = (menus) => {
  return menus.find(
    (
      /** @type {MenuDto} */
      menu,
    ) => menu.activo === 'S' && menu.programa && menu.programa.substring(0, 4) !== 'http',
  )
}

export default findStartRoute
